import { useState } from 'react';
import Button from 'src/components/buttons/button';
import NumberedList from 'src/components/numberedList';
import config from 'config/config';
import Icon from 'src/components/icon';

const PROGRAM_URL = `${config.cdn.navigator}living-with-high-blood-pressure/`;

const getMenu = () => (
  <section className="navigator__contents">
    <div className="navigator__contents-header">Contents</div>
    <ul className="navigator__contents__list">
      <li><div className="navigator__contents__number">1.</div><div className="navigator__contents__content-text"><a href="#1">How to set goals and stick to them</a></div></li>
      <li><div className="navigator__contents__number">2.</div><div className="navigator__contents__content-text"><a href="#2">How to get your five-a-day</a></div></li>
      <li><div className="navigator__contents__number">3.</div><div className="navigator__contents__content-text"><a href="#3">The 10 minute living room workout</a></div></li>
      <li><div className="navigator__contents__number">4.</div><div className="navigator__contents__content-text"><a href="#4">The BHF weight loss guide</a></div></li>
    </ul>
  </section>
);

const getPage = () => (
  <div className="navigator">
    <section className="navigator__content">
      <h1 className="navigator__title">
        {'Week 10: Keeping up healthy changes'}
      </h1>
      <p>{`People with high blood pressure need to make sure they maintain a healthy weight to help their blood pressure reach a healthy level. This week we're sharing common pitfalls, motivational advice and the complete BHF weight loss guide.`}</p>
      <div className="visible-xs">{getMenu()}</div>

      <h2>How to set goals and stick to them</h2>
      <p>{`Starting a new, healthier lifestyle can be exciting. But after a while you may find old habits start creeping in and undoing your hard work. We're sharing our top 3 tips to make sure you stick to your goals and lower your blood pressure.`}</p>
      <NumberedList items={[
        `Focus on what you want to eat rather than what you don't. For example, making sure you have vegetables at every meal feels more positive than obsessing about what to avoid.`,
        `Break it down. Sometimes long-term goals can be intimidating, so try breaking each one down into smaller, achievable aims. What choices can you make today, right now, to improve your blood pressure?`,
        `Rehearse barriers. Life is unpredictable and things will knock you off-track. It's important to see these coming and think about how you're going to deal with them ahead of time. Look at online menus before going to restaurants and practice saying no thanks to unwanted calories. Remember, every time you make a good choice, you're building a habit and making it easier next time.`]
      }
      />
      <a href="https://www.bhf.org.uk/heart-matters-magazine/wellbeing/how-to-set-goals" rel="noreferrer" target="_blank">
        Read all 10 goal setting tips here {'>'}
      </a>
      <img className="navigator__image-full" src={`${PROGRAM_URL}wk10-cant.jpg`} />

      <h2>Easy swaps to get your five-a-day </h2>
      <p>{`Most people would benefit from eating more vegetables and fruit. They're a really important part of having a balanced diet and a key part of losing weight. If you're struggling to fit in your 5 portions of fruit and veg a day, here are some simple tips to get you started.`}</p>
      <div className="navigator__video-container">
        <iframe
          allow="autoplay; encrypted-media; fullscreen"
          src="https://www.youtube.com/embed/Uj8_Na-3YBA"
        />
      </div>

      <h2>Try the 10-minute living room workout</h2>
      <p>{`You don't need to join a gym or buy expensive equipment to get more activity into your day. BHF Physical Activity Specialist Lisa Young has created a fuss-free 10-minute workout you can do from your living room.`}</p>
      <p>{`This is a great way to start working out. You'll build your fitness and confidence gradually, but every 10 minutes will count towards lowering your blood pressure in the long term - make sure you keep it up.`}</p>
      <div className="navigator__video-container">
        <iframe
          allow="autoplay; encrypted-media; fullscreen"
          src="https://www.youtube.com/embed/O5YX5xg8Seg"
        />
      </div>

      <h2>Get more info with the BHF weight loss booklet</h2>
      <p>{`This BHF booklet is packed with advice and ideas to help you make healthy changes. Remember that eating well and becoming a healthy weight is really important for lowering blood pressure and improving heart health.`}</p>
      <img className="navigator__image-full" src={`${PROGRAM_URL}wk10-booklet.png`} />
      <a href="https://www.bhf.org.uk/publications/healthy-eating-and-drinking/facts-not-fads---your-simple-guide-to-healthy-weight-loss" rel="noreferrer" target="_blank">
        <Button
          icon="open-right"
          iconLeftAligned={false}
          text={'Download the Healthy Weight Loss guide'}
        />
      </a>

      <img alt="Content provided by BHF" className="navigator__image-full navigator__banner-footer" src={`${PROGRAM_URL}bhf-content.jpg`} />
    </section>
  </div>
);

function Footer() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;
  return (
    <div className="navigator__footer">
      <img alt="HealthUnlocked British Heart Foundation community screenshot" className="navigator__footer__image" src={`${PROGRAM_URL}cta-community.png`} />
      <div className="navigator__footer__inner">
        <div className="navigator__footer__title">
          Join the conversation on HealthUnlocked
        </div>
        <div className="navigator__footer__description">
          {`To get the most out of your heart health journey, you'll need support. Our online community on HealthUnlocked brings patients, their loved-ones and healthcare experts all together online to share advice and encouragement. `}
          <a
            className="navigator__footer__link"
            href="https://healthunlocked.com/bhf"
            rel="noreferrer"
            target="_blank"
          >
            Join the conversation {'>'}
          </a>
        </div>
        <div className="navigator__footer__close" onClick={() => setVisible(false)}>
          <Icon icon="cross" />
        </div>
      </div>
    </div>
  );
}

const obj = {
  getPage,
  getMenu,
  Footer,
  getSeoTitle: 'Living with high blood pressure | HealthUnlocked',
};

export default obj;
